const reports = (axios) => {
  const sendReportByType = (type, reportId) => {
    return axios.post(`/report/sendto/${type}/${reportId}`);
  };

  return {

    /**
         * Report index page
         */
    index: {

      /**
             * @param params
             * @method get
             * @api /api/reports/get_all?page={page}&ppage={ppage}
             */
      get (params) {
        return axios.get(`/reports/get_all?page=${params.page}&ppage=${params.perPage}`)
          .then((response) => response);
      },

    },

    /**
         * @param  id
         * @method get
         * @api /api/reports/{id}
         */
    get (id) {
      return axios.get(`/report/${id}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method post
         * @api /api/errors/delete/
         */
    deleteError (params) {
      return axios.post(`/errors/delete/${params}`)
        .then((response) => response);
    },

    /**
         * @param data
         * @method post
         * @api /api/report/editReport
         */
    sendToCustomer (params) {
      return axios.post('/report/editReport/', params)
        .then((response) => response);
    },

    /**
         * @param id
         * @method post
         * @api /api/report/send_to_lsp/{reportid}
         */
    sendToLsp(id) {
      return axios.post(`/report/send_to_lsp/${id}`);
    },

    /**
         * @param id
         * @method get
         * @api /api/ErrorConclusion/{id}
         */
    getErrorConclusion (params) {
      return axios.get(`/ErrorConclusion/${params}`)
        .then((response) => response);
    },

    /**
         * @param {Object} params
         * @method post
         * @api /api/error_conclusions/comments/edit
         */
    changeCommentErrorConclusion (params) {
      return axios.post('/error_conclusions/comments/edit', params)
        .then((response) => response);
    },

    /**
         * @param {Object} params
         * @method post
         * @api /api/error_conclusions/comments/edit
         */
    addCommentErrorConclusion (params) {
      return axios.post('/error_conclusions/comments/add', params)
        .then((response) => response);
    },

    /**
         * @param {Object} params
         * @method post
         * @api /api/error_conclusions/update_item/{repId}
         */
    changeErrorConclusionItem (reportId, params) {
      return axios.post(`/error_conclusions/update_item/${reportId}`, params)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/reportConclusions/getComments/{id}
         */
    getReportsComments (params) {
      return axios.get(`/reportConclusions/getComments/${params}`)
        .then((response) => response);
    },

    /**
         * @param data
         * @method post
         * @api /api/
         */
    updateReportsComments (params) {
      return axios.post('/reportConclusions/updateComment/', params)
        .then((response) => response);
    },

    /**
         * @param data
         * @method post
         * @api /api/
         */
    removeReportsComments (params) {
      return axios.post('/reportConclusions/removeComment/', params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/report_comment/get/
         */
    getAllComments (params) {
      return axios.get(`/report_comment/get/${params.id}?page=${params.page}&ppage=${params.perPage}`)
        .then((response) => response);
    },

    /**
         * @param reportId
         * @param commentCountOnPage
         * @method post
         * @api /api/report_comment/get_count/
         */
    getCountPageComments (reportId, commentCountOnPage) {
      return axios.post(`/report_comment/get_count/${reportId}/${commentCountOnPage}`)
        .then((response) => response);
    },

    /**
         * @param params
         * @api /api/report_comment/add/
         */
    sendComment (params) {
      return axios.post('/report_comment/add/', params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method get
         * @api /api/...
         */
    getHistory (params) {
      return axios.get(`/report/item/history/${params.id}?page=${params.page}&ppage=${params.perPage}`)
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/report/get_er_stat/{id}
         */
    getStatistics (id) {
      return axios.get(`/report/get_er_stat/${id}`)
        .then((response) => response);
    },

    /**
         *
         * @param params
         * @api /api/report/inconsist/${id}
         */
    getInconsistencies (id, params) {
      return axios.get(`/report/inconsist/${id}?page=${params.page}&ppage=${params.ppage}&difference_source_id=${params.difference_source_id}`)
        .then((response) => response);
    },

    /**
         *
         * @param params
         * @api /api/report/inconsist/diff
         */
    getInconsistenciesDiff (params) {
      return axios.post('/report/inconsist/diff', params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method post
         * @api /api/errors/correction_update
         */
    correctionUpdate (params) {
      return axios.post('/errors/correction_update/', params)
        .then((response) => response);
    },

    /**
         * @param error
         * @method post
         * @api /api/errors/addComment
         */
    sendErrorItemComment (params) {
      return axios.post('/errors/addComment', params)
        .then((response) => response);
    },

    /**
         * @param error
         * @method post
         * @api /api/errors/comment_update
         */
    updateErrorItemComment (params) {
      return axios.post('/errors/comment_update', params)
        .then((response) => response);
    },

    /**
         * @param error
         * @method post
         * @api /api/errors/comment/remove
         */
    removeErrorItemComment (params) {
      return axios.post('/errors/comment/remove', params)
        .then((response) => response);
    },

    /**
         * @param error
         * @method post
         * @api /api/errors/itemUpdate
         */
    updateErrorItem (params) {
      return axios.post('/errors/itemUpdate', params)
        .then((response) => response);
    },

    /**
         * @param params
         * @method get
         * @api /api/errors/itemUpdate
         */
    getErrorsItem (params) {
      return axios.get(`/reports/geterrors/${params.id}?page=${params.page}&ppage=${params.perPage}`, {
        params: params.params || '',
      })
        .then((response) => response);
    },

    /**
         * @param id
         * @method get
         * @api /api/errors/get_er_comments/28593
         */
    getErrorsItemComment (id) {
      return axios.get(`/errors/get_er_comments/${id}`)
        .then((response) => response);
    },

    comments: {

      /**
             * Method for remove comment
             *
             * @param {Array} params
             */
      removeComment (params) {
        return axios.post('/report_comment/remove', params)
          .then((response) => response);
      },

      /**
             * Method for change comment
             *
             * @param {Array} params
             */
      editComment (params) {
        return axios.post('/report_comment/edit', params)
          .then((response) => response);
      },
    },

    sendReport: {
      lsp: (reportID) => sendReportByType('LSP', reportID),
      projectManager: (reportID) => sendReportByType('PM', reportID),
      proofReader: (reportID) => sendReportByType('PR', reportID),
      customer: (reportID) => sendReportByType('PM', reportID),
      qaExpert: (reportID) => sendReportByType('QAE', reportID),
    },

  };
};

export default reports;
